export const PAGE_TENTANG_KAMI = "/tentang-kami"
export const PAGE_INFORMASI_TERKINI = "/informasi-terkini"
export const PAGE_BAITUL_MAAL = "/baitul-maal"
export const PAGE_BISNIS_ANGGOTA = "/bisnis-anggota"
export const PAGE_DAFTAR_ANGGOTA = "/daftar-anggota"
export const PAGE_PRODUK_KAMI = "/produk-kami"
export const PAGE_STRUKTUR_ORGANISASI = "/struktur-organisasi"


//* ADMIN
export const PAGE_ADMIN_LOGIN = "/pages-admin"

export const API_BAITUL_MAAL=`v1${PAGE_BAITUL_MAAL}`
export const API_BISNIS_ANGGOTA=`v1${PAGE_BISNIS_ANGGOTA}`
export const API_INFORMASI_TERKINI=`v1${PAGE_INFORMASI_TERKINI}`
export const API_PENGATURAN_USER = `v1/users`
export const API_SALDO = `v1/saldo`







